<style lang="stylus">
    .slide-ehart-box
        position absolute
        left 0
        top 0
        width 0
        height 0
        .shapebox
            width 100%
            height 100%
            pointer-events auto
            transform-origin 0 0
            > div
                cursor pointer!important
</style>

<template>
    <div
        v-show="show"
        class="slide-ehart-box"
        :style="{
            width: `${chartInfo.position.width}px`,
            height: `${chartInfo.position.height}px`,
        }"
    >
        <div
            @click.stop
            class="shapebox"
            ref="main"
            :style="{
                transform: chartInfo.position.shapetMt,
            }"
        ></div>
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue } from "vue-property-decorator";
    import * as echarts from "echarts";
    import { fixSetOption } from "@/app/components/LeftPanel/ChartData";
    import { chartData } from "@/app/components/FloatTool/echart/chartData";
    declare var EchartTheme: any;

    @Component
    export default class EchartBox extends Vue {
        @Prop()
        chartInfo;

        chart = null;
        show = true;
        initChart(option) {
            this.$nextTick(() => {
                let main = this.$refs.main as HTMLElement;
                this.chart && echarts.dispose(this.chart);
                this.chart = echarts.init(main, undefined, { renderer: this.chartInfo.isPageSlide ? "canvas" : "svg", devicePixelRatio: 4 });
                let originOption = JSON.parse(option);
                if (this.chartInfo.chartType === "sankey") {
                    originOption.series.forEach((item) => (item.draggable = false));
                }
                this.chart.setOption(
                    fixSetOption(
                        Object.assign(originOption, {
                            animation: true,
                        })
                    )
                );
                this.setSunburstRootToNode(originOption);
            });
        }

        // 旭日图下钻的根节点ID
        setSunburstRootToNode(optionObj) {
            if (optionObj.edSunburstRootNodeId) {
                this.chart.dispatchAction({
                    type: "sunburstRootToNode",
                    targetNode: optionObj.edSunburstRootNodeId,
                    animation: false,
                });
            }
        }

        created() {}
        mounted() {
            EchartTheme.registerEchartTheme(echarts);
            this.chartInfo && this.initChart(this.chartInfo.option);
        }
        beforeDestroy() {
            this.chart = null;
        }
    }
</script>
<i18n>
{
    "zh": {},
    "en": {},
    "fr": {},
    "de": {},
    "jp": {},
    "es": {},
    "pt": {},
    "it": {},
    "tw": {},
    "kr": {}
}
</i18n>
